import React from 'react';
import PropTypes from 'prop-types';
import useCit from '~/utils/cit/hook';
import * as States from '~/assets/cit';
import { upperCase } from 'lodash';

const CitSeal = ({ state }) => {
  const { authStatus } = useCit();

  return authStatus === 'VALID'
    ? null
    : (
      <p className="text-center">
        <img src={States[upperCase(state)]} alt={`${state} CIT program`} />
      </p>
    );
};

CitSeal.propTypes = {
  state: PropTypes.string.isRequired,
};

export default CitSeal;

